




















import {Component, Vue} from 'vue-property-decorator';

@Component
  export default class extends Vue {
    private get active():string {
      // TODO: ちゃんと実装する
      const s = this.$route.name!.split('.');
      return `${s[0]}.${s[1]}.${s[2]}`;
    }
    private set active(val:string) {
      if(this.$route.name === val) return;
      this.$router.push(this.getRoute(val));
    }
    private getRoute(name) {
      const companyId = this.$route.params.companyId || this.$auth.user.company.id;
      return {name: name, params: {companyId: companyId as any} };
    }
  }
